// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__hCwnb","content":"GlobalSearch_content__3GYOo"};